import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Parser from 'html-react-parser';
import AuLogo from '../../../../assets/Images/autommate-transparent.png';
import Details from './Details';
import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
/**
 * @Description This function lets you return Bot card component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Card({ bot, type }) {
    const label = 'CONTENT.BOT.';
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();
    const handleClick = () => {
        setOpen(true);
    };

    const appImages = bot.application_image?.split('##');
    const appNames = bot.application_name?.split(',');
    const totalAppSize = appImages?.length;

    let bpn = bot.business_process_name?.split(',');
    let cn = bot.categories_name?.split(',');

    function htmlToText(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    }

    return (
        <div className="bot-card">
            <div className='bot-header-new'>
                <div className='bot-name-text'>{bot.bot_name}</div>
                <div className='bot-type-text'>{bot.automation_type_name}</div>
                <div className='bot-description-new'>
                    <p>
                        {bot.short_description ? htmlToText(bot.short_description.replace(/&nbsp;/gi, '')) : ''}
                        {
                            bot.short_description && bot.short_description.length > 100 &&
                            <span className='read-more'><span>...</span> <span onClick={handleClick} className='read-more-button'>read more</span></span>
                        }
                    </p>

                </div>
                <div className='badge-area'>
                    <div className="badge-container">
                        {bpn?.map((item, itemI) => {
                            if (itemI < 1) {
                                return <div className="badge-item red" key={itemI}>{item}</div>
                            }
                        })}
                        {bpn?.length > 1 ? <Tooltip title={bpn?.slice(1, bpn?.length).join(', ')}><span
                            className="badge-plus">+{bpn?.length - 1}</span></Tooltip> : null}
                    </div>
                    <div className="badge-container m-l-30">
                        {cn?.map((item, itemI) => {
                            if (itemI < 1) {
                                return <div className="badge-item blue" key={itemI}>{item}</div>
                            }
                        })}
                        {cn?.length > 1 ? <Tooltip title={cn?.slice(1, cn?.length).join(', ')}><span
                            className="badge-plus">+{cn?.length - 1}</span></Tooltip> : null}
                    </div>
                </div>
            </div>
            <div className='card-divider'></div>
            <div className='bot-body'>
                <div className='compatible-title'>Compatible with</div>
                {
                    appImages?.length > 0 ?
                        <>
                            {
                                appImages?.map((item, itemI) => {
                                    if (itemI <= 1)
                                        return <div className='items-center' style={{ margin: '15px 0' }} key={itemI}>
                                            <div className="new-compatible-logo">
                                                <img className='compatible-img' src={item} alt={appNames[itemI]} />
                                            </div>

                                            <div className='compatible-app-name'>{appNames[itemI]}</div>
                                        </div>
                                })
                            }
                            {
                                appImages?.length > 2 ? (
                                    <Tooltip title={appNames?.slice(2, appNames?.length).join(', ')}><span
                                        className="badge-plus">+ {totalAppSize - 2} more</span>
                                    </Tooltip>
                                ) :
                                    appImages?.length === 1 ?
                                        <div className='h-61-px'></div> :
                                        <div className='h-11-px'></div>
                            }
                        </> :
                        <div className='empty-compatible'></div>
                }
            </div>
            <div className='card-divider'></div>
            <div className='bot-footer items-center-between'>
                <div className='developed-by'><span>Developed by</span> <span className='bot-vendor-name'>Autom Mate</span></div>
                <Button className='get-autom-button' onClick={handleClick}>More Info</Button>
            </div>
            {open && <Details setOpen={setOpen} bot={bot} />}
        </div>
    );
}

export default Card;
